/* eslint-disable max-len */
import {path, params, pathWithParams, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {useAxios} from '@sttedra_ui/framework';
import {sucessCustom} from '@/utils/successHandling';

// #region Globals
const {base} = useAxios();
const servicio = 'Comun';
// #endregion

async function getConfigureAudit(_userId, _tipoLogin) {
  const url = `${path}${_userId}/-1/${servicio}/ConfigureAudit/${_tipoLogin}?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    if (error.code === 500) window.location.href = '/FalloIniciarSesion';
    handleErrorCustom(error);
  }
}

async function getEnums() {
  const url = `${path}${params.value.userId}/-1/${servicio}/GetEnums?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getTiposOrgano() {
  const url = `${pathWithParams()}${servicio}/GetTiposOrgano?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getDescriptionEnums() {
  const url = `${pathWithParams()}${servicio}/GetDescriptionEnums?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getMaestras(_id) {
  const url = `${pathWithParams()}${servicio}/GetMaestras/${_id}?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getResetApi() {
  const url = `${pathWithParams()}${servicio}/ResetApi?${apiVersion}`;
  try {
    const data = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    sucessCustom(data.message);
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getSizeCache() {
  const url = `${pathWithParams()}${servicio}/GetSizeCache?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}


export {
  getConfigureAudit,
  getEnums,
  getDescriptionEnums,
  getMaestras,
  getTiposOrgano,
  getSizeCache,
  getResetApi,
};
